import { render, staticRenderFns } from "./orderDetailMaterial.vue?vue&type=template&id=2f707e71&scoped=true&"
import script from "./orderDetailMaterial.vue?vue&type=script&lang=js&"
export * from "./orderDetailMaterial.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailMaterial.vue?vue&type=style&index=0&id=2f707e71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f707e71",
  null
  
)

export default component.exports